/* cc-rw-drawer.js (Curlfriend Rewards v2, 17 Oct 2026)
   Behaviour for snippets/cc-rw-drawer.liquid, the "Your rewards" row in the cart drawer.
   Loaded once from snippets/cart-drawer.liquid in the initial HTML (a script that arrives by innerHTML never runs),
   so every handler here is delegated and survives drawer re-renders.

   1. ONE-TAP $-OFF / FREE SHIPPING. Claims the reward with the LoyaltyLion storefront SDK
      (window.loyaltylion.api.customers.claimReward, the same call LoyaltyLion's own "Get reward" button makes;
      NOT a documented public API, so every step is guarded and falls back to the rewards page), then applies the
      code to the cart with /cart/update.js { discount } and redraws the drawer from the returned sections.
   2. SEAMLESS FREE PRODUCTS. LoyaltyLion's own button handles the claim and adds the "(Reward)" product;
      this file only redraws the drawer when LoyaltyLion reports the cart changed.
   3. SIGNED-OUT MEMBERS. A logged-in drawer stores the balance in localStorage; a signed-out drawer in the same
      browser then reads "Log in to use your $X" instead of "Join free".
   4. R2 (22 Oct): every refused or failed claim logs the full response to console.warn ("[ccrw]") and pushes
      loyalty_drawer_claim_fail with status and message. ?ccrw_debug=1 (kept for the browser session) also prints
      them in the row, plus what the SDK exposes, so the reason can be read on a phone. Off by default.
   5. SAVED REWARDS (22 Oct): a code this browser claimed that is not in the cart shows first as "Your saved $X"
      with Apply, which only posts /cart/update.js { discount } (no new claim). Source: codes claimed here (localStorage
      ccrw_saved, 30 days, the code life). Codes claimed elsewhere are not listed: no documented SDK read was available.
   6. REFUSED ONCE (R2c, Mike 22 Oct): when LoyaltyLion refuses a claim with a 4xx (it sends no reason), the browser
      remembers it for the session (sessionStorage ccrw_refused). Every Use button then links to the rewards page
      and the row says so up front, instead of offering a tap that cannot work. Saved-code Apply is unaffected.
*/
(function () {
  if (window.ccRwReady) return;
  window.ccRwReady = true;
  var KEY = 'ccrw_bal';
  var SAVED = 'ccrw_saved';
  var DAY = 86400000;
  var dbg = false;
  try {
    if (/[?&]ccrw_debug=1/.test(location.search)) window.sessionStorage.setItem('ccrw_debug', '1');
    if (/[?&]ccrw_debug=0/.test(location.search)) window.sessionStorage.removeItem('ccrw_debug');
    dbg = window.sessionStorage.getItem('ccrw_debug') === '1';
  } catch (e) { dbg = /[?&]ccrw_debug=1/.test(location.search); }

  function push(event, params) {
    window.dataLayer = window.dataLayer || [];
    var o = { event: event };
    for (var k in params) if (Object.prototype.hasOwnProperty.call(params, k)) o[k] = params[k];
    window.dataLayer.push(o);
  }

  var live = null;
  function announce(text) {
    if (!live || !document.body.contains(live)) {
      live = document.createElement('div');
      live.className = 'visually-hidden';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 120);
  }

  function store(get, val) {
    try {
      if (get) return window.localStorage.getItem(KEY);
      if (val) window.localStorage.setItem(KEY, val); else window.localStorage.removeItem(KEY);
    } catch (e) { return null; }
  }

  /* Balance memory and the signed-out swap. Runs on load and after every drawer redraw. */
  function sync() {
    var rows = document.querySelectorAll('[data-ccrw]');
    rows.forEach(function (row) {
      var state = row.getAttribute('data-ccrw-state');
      if (state === 'member' || state === 'applied') {
        var bal = row.getAttribute('data-ccrw-bal') || '';
        if (bal && bal !== '$0') store(false, bal); else store(false, '');
      } else if (state === 'guest') {
        var saved = store(true);
        var p = row.querySelector('[data-ccrw-guest]');
        if (saved && p && !p.hasAttribute('data-ccrw-swapped')) {
          p.setAttribute('data-ccrw-swapped', '');
          p.innerHTML = '';
          var a = document.createElement('a');
          a.href = '/account/login?return_url=/cart';
          a.textContent = 'Log in to use your ' + saved;
          p.appendChild(a);
          row.setAttribute('data-ccrw-state', 'login');
        }
      }
    });
  }

  /* Saved codes: [{ code, label, t }], newest first, dropped after 30 days. */
  function savedList() {
    var list = [];
    try { list = JSON.parse(window.localStorage.getItem(SAVED) || '[]') || []; } catch (e) { list = []; }
    var now = Date.now();
    return list.filter(function (x) { return x && x.code && now - (x.t || 0) < 30 * DAY; });
  }
  function savedWrite(list) {
    try { window.localStorage.setItem(SAVED, JSON.stringify(list.slice(0, 6))); } catch (e) {}
  }
  function savedAdd(code, label) {
    var list = savedList().filter(function (x) { return x.code.toUpperCase() !== code.toUpperCase(); });
    list.unshift({ code: code, label: label, t: Date.now() });
    savedWrite(list);
  }

  /* Reason for a failed step, from whatever the SDK or fetch gave back. */
  function reasonOf(x) {
    var r = { status: '', message: '' };
    if (!x) return r;
    var e = x.error || x;
    r.status = String(e.status || e.statusCode || e.code || (x.response && x.response.status) || '');
    var m = e.message || e.description || e.detail || e.error_description || (e.errors && JSON.stringify(e.errors)) || '';
    if (!m && typeof e === 'object') { try { m = JSON.stringify(e).slice(0, 300); } catch (z) { m = String(e); } }
    r.message = String(m).slice(0, 300);
    return r;
  }
  function warn(step, raw) {
    try { console.warn('[ccrw] ' + step, raw); } catch (e) {}
  }
  /* Debug trace (R2b): every step of a tap, kept in sessionStorage so a drawer redraw or reload cannot wipe it. */
  function dlog(line) {
    if (!dbg) return;
    var t = new Date();
    var stamp = ('0' + t.getMinutes()).slice(-2) + ':' + ('0' + t.getSeconds()).slice(-2);
    try {
      var a = JSON.parse(window.sessionStorage.getItem('ccrw_dlog') || '[]');
      a.push(stamp + ' ' + String(line).slice(0, 220));
      window.sessionStorage.setItem('ccrw_dlog', JSON.stringify(a.slice(-10)));
    } catch (e) {}
    debugPaint();
  }
  function dtrace() {
    try { return JSON.parse(window.sessionStorage.getItem('ccrw_dlog') || '[]'); } catch (e) { return []; }
  }
  function short(x) {
    try { return JSON.stringify(x).slice(0, 200); } catch (e) { return String(x).slice(0, 200); }
  }

  /* Debug: what the LoyaltyLion SDK exposes here (names only, never tokens). */
  function sdkReport() {
    var ll = window.loyaltylion, o = [];
    if (!ll) return 'SDK: not on page';
    o.push('SDK ' + (ll.version || '?'));
    var c = ll.api && ll.api.customers;
    if (!c) { o.push('api.customers: missing'); return o.join(' | '); }
    var names = [], seen = {};
    for (var p = c; p && p !== Object.prototype; p = Object.getPrototypeOf(p)) {
      Object.getOwnPropertyNames(p).forEach(function (n) { if (!seen[n] && n !== 'constructor' && typeof c[n] === 'function') { seen[n] = 1; names.push(n); } });
    }
    o.push('customers: ' + (names.join(', ') || 'none'));
    ['claimReward', 'redeemShopifyFunctionReward'].forEach(function (n) {
      if (typeof c[n] === 'function') o.push(n + ': ' + String(c[n]).replace(/\s+/g, ' ').slice(0, 120));
    });
    o.push('authPacket: ' + (ll.api && ll.api.authPacket ? 'yes' : 'no'));
    var sp = document.querySelector('cart-drawer [data-ccrw-seamless], .cart__footer [data-ccrw-seamless]');
    if (sp) o.push('seamless ' + sp.getAttribute('data-lion-seamless-product-reward') + ' (LL ' + (sp.getAttribute('data-ccrw-ll-id') || '?') + '): ' + (sp.querySelector('.lion-in-cart-reward__button,.lion-action-button,button') ? 'LL button rendered' : 'no LL button'));
    return o.join(' | ');
  }
  function debugPaint() {
    if (!dbg) return;
    document.querySelectorAll('[data-ccrw]').forEach(function (row) {
      var d = row.querySelector('[data-ccrw-dbg]');
      if (!d) { d = document.createElement('p'); d.className = 'ccrw__dbg'; d.setAttribute('data-ccrw-dbg', ''); row.appendChild(d); }
      var tr = dtrace();
      var t = (tr.length ? 'TRACE\n' + tr.join('\n') + '\n\n' : '') + sdkReport();
      if (d.textContent !== t) d.textContent = t;
    });
  }

  function findCode(obj, depth) {
    if (!obj || depth > 6) return null;
    if (typeof obj === 'string') return /^LL-[A-Z0-9]{4,}$/i.test(obj) ? obj : null;
    if (typeof obj !== 'object') return null;
    if (typeof obj.code === 'string' && obj.code.length > 3) return obj.code;
    for (var k in obj) {
      if (!Object.prototype.hasOwnProperty.call(obj, k)) continue;
      var c = findCode(obj[k], (depth || 0) + 1);
      if (c) return c;
    }
    return null;
  }

  function redraw(state) {
    /* On the cart page the row sits in main-cart-footer, which this file cannot redraw: reload so the total updates. */
    if (/\/cart\/?$/.test(location.pathname) && document.querySelector('.cart__footer [data-ccrw]')) { location.reload(); return; }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && state && state.sections && typeof drawer.renderContents === 'function') {
      drawer.renderContents(state);
    }
    setTimeout(sync, 60);
  }

  function sectionsRefresh() {
    return fetch('/?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) { redraw({ sections: sections }); });
  }

  function lionCartSync() {
    var lion = window.lion || window.loyaltylion;
    if (!lion || typeof lion.setCartState !== 'function') return;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (cart) { try { lion.setCartState(cart); } catch (e) {} });
  }

  /* Claim refused or threw: nothing was claimed, so no points moved. */
  function fail(row, btn, label, reason, step) {
    reason = reason || { status: '', message: '' };
    row.removeAttribute('data-ccrw-busy');
    if (btn) { btn.disabled = false; btn.textContent = btn.getAttribute('data-ccrw-txt') || 'Use'; }
    var msg = row.querySelector('[data-ccrw-msg]');
    if (msg) {
      msg.hidden = false;
      msg.className = 'ccrw__err';
      msg.innerHTML = 'We couldn’t add it here. Your points are safe. <a href="/pages/rewards#ccr-member">Use it from your rewards page</a>.';
      if (dbg) {
        var d = document.createElement('small');
        d.className = 'ccrw__dbg';
        d.textContent = '[' + (step || 'claim') + '] status: ' + (reason.status || 'none') + ', message: ' + (reason.message || 'none');
        msg.appendChild(d);
      }
    }
    announce('We could not add your reward here. Your points are safe. Use it from your rewards page.');
    push('loyalty_drawer_claim_fail', { loyalty_reward: label, status: reason.status, message: reason.message, step: step || 'claim' });
    dlog('FAIL shown [' + (step || 'claim') + '] ' + (reason.status || 'none') + ' ' + (reason.message || ''));
    if ((step || 'claim') === 'claim' && /^4\d\d$/.test(String(reason.status))) {
      try { window.sessionStorage.setItem('ccrw_refused', String(Date.now())); } catch (e) {}
      setTimeout(applyRefused, 0);
    }
    try { window.sessionStorage.setItem('ccrw_fail', JSON.stringify({ t: Date.now(), d: (step || 'claim') + '] status: ' + (reason.status || 'none') + ', message: ' + (reason.message || 'none') })); } catch (e) {}
  }
  /* After a refusal: Use buttons become links to the rewards page for the rest of the session. */
  function applyRefused() {
    var on = false;
    try { on = !!window.sessionStorage.getItem('ccrw_refused'); } catch (e) {}
    if (!on) return;
    document.querySelectorAll('[data-ccrw-claim]').forEach(function (b) {
      var a = document.createElement('a');
      a.className = 'ccrw__use';
      a.href = '/pages/rewards#ccr-member';
      a.textContent = 'Use';
      a.setAttribute('data-ccrw-refused', '');
      a.setAttribute('aria-label', (b.getAttribute('aria-label') || 'Use') + ' from your rewards page');
      b.parentNode.replaceChild(a, b);
    });
    document.querySelectorAll('[data-ccrw]').forEach(function (row) {
      if (!row.querySelector('[data-ccrw-refused]')) return;
      var msg = row.querySelector('[data-ccrw-msg]');
      if (!msg || !msg.hidden) return;
      msg.hidden = false;
      msg.className = 'ccrw__err';
      msg.innerHTML = 'Your points are safe. <a href="/pages/rewards#ccr-member">Use it from your rewards page</a>.';
    });
  }

  /* A drawer redraw right after a failure would wipe the message: show it again for 60 seconds. */
  function repaintFail() {
    var f = null;
    try { f = JSON.parse(window.sessionStorage.getItem('ccrw_fail') || 'null'); } catch (e) {}
    if (!f || Date.now() - f.t > 60000) return;
    document.querySelectorAll('[data-ccrw]').forEach(function (row) {
      var msg = row.querySelector('[data-ccrw-msg]');
      if (!msg || !msg.hidden) return;
      msg.hidden = false;
      msg.className = 'ccrw__err';
      msg.innerHTML = 'We couldn’t add it here. Your points are safe. <a href="/pages/rewards#ccr-member">Use it from your rewards page</a>.';
      if (dbg) { var d = document.createElement('small'); d.className = 'ccrw__dbg'; d.textContent = '[' + f.d; msg.appendChild(d); }
    });
  }

  function findApplied(state) {
    var list = (state && state.discount_codes) || [];
    for (var i = 0; i < list.length; i++) if (list[i].code && list[i].code.toUpperCase() === pendingCode.toUpperCase()) return list[i];
    return null;
  }
  function codesFor(state) {
    return ((state && state.discount_codes) || []).map(function (d) { return d.code; }).filter(Boolean).join(',');
  }
  /* A freshly claimed LoyaltyLion code can take a few seconds to become usable in Shopify (seen 17 Oct: the
     cart reported applicable:false right after the claim, true a few minutes later). Re-post the same codes at
     3s, 6s and 10s before giving up and treating it as pending. */
  var pendingCode = '';
  function settle(state, codes, attempt) {
    var hit = findApplied(state);
    if (!hit || hit.applicable || attempt >= 3) return state;
    var wait = [3000, 6000, 10000][attempt];
    return new Promise(function (res) { setTimeout(res, wait); }).then(function () {
      return fetch((window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: codes, sections: ['cart-drawer', 'cart-icon-bubble'] })
      }).then(function (r) { return r.json(); }).then(function (s2) { return settle(s2, codes, attempt + 1); });
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-ccrw-claim]');
    if (!btn) return;
    event.preventDefault();
    var row = btn.closest('[data-ccrw]');
    dlog('tap Use ' + btn.getAttribute('data-ccrw-claim') + (row && row.hasAttribute('data-ccrw-busy') ? ' (ignored: busy)' : ''));
    if (!row || row.hasAttribute('data-ccrw-busy')) return;
    try { window.sessionStorage.removeItem('ccrw_fail'); } catch (e) {}
    var id = parseInt(btn.getAttribute('data-ccrw-claim'), 10);
    var label = btn.getAttribute('data-ccrw-label') || 'reward';
    var ll = window.loyaltylion;
    if (!id || !ll || !ll.api || !ll.api.customers || typeof ll.api.customers.claimReward !== 'function') {
      var why = !id ? 'no reward id' : !ll ? 'SDK not on page' : 'claimReward missing';
      warn('guard', why);
      fail(row, btn, label, { status: 'guard', message: why }, 'guard');
      return;
    }
    row.setAttribute('data-ccrw-busy', '');
    btn.disabled = true;
    btn.textContent = 'Adding';
    push('loyalty_drawer_claim_click', { loyalty_reward: label });

    var code = null;
    var step = 'claim';
    var claimed = false;
    Promise.resolve()
      .then(function () { dlog('claimReward start ' + id); return ll.api.customers.claimReward({ rewardId: id }); })
      .then(function (res) {
        dlog('claimReward resolved ' + short(res));
        /* The SDK resolves (not rejects) with { error: { status } } on a refused claim. Tested 17 Oct: a
           string `source` is refused with 400, so none is sent. */
        if (res && res.error) { warn('claim refused', res); var e1 = new Error('claim refused'); e1.ccrw = reasonOf(res); throw e1; }
        code = (res && res.claimedReward && res.claimedReward.redeemable && res.claimedReward.redeemable.code) || findCode(res && res.claimedReward, 0);
        if (!code) { warn('claim gave no code', res); var e2 = new Error('no code'); e2.ccrw = { status: 'no code', message: reasonOf(res).message }; throw e2; }
        claimed = true;
        step = 'apply';
        savedAdd(code, label);
        pendingCode = code;
        dlog('claimed ' + code + ', applying');
        return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        var codes = (cart.discount_codes || []).map(function (d) { return d.code; })
          .filter(function (c) { return c && c.toUpperCase() !== code.toUpperCase(); });
        codes.push(code);
        return fetch((window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: codes.join(','), sections: ['cart-drawer', 'cart-icon-bubble'] })
        }).then(function (r) { return r.json(); });
      })
      .then(function (state) { dlog('cart codes ' + short(state && state.discount_codes)); return settle(state, codesFor(state), 0); })
      .then(function (state) {
        var hit = findApplied(state);
        if (!hit) { warn('code not on cart', state && state.discount_codes); var e3 = new Error('not applied'); e3.ccrw = { status: 'not applied', message: code }; throw e3; }
        if (hit.applicable) dropSaved(code);
        dlog('applied ' + code + ' applicable=' + hit.applicable);
        redraw(state);
        lionCartSync();
        if (hit.applicable) {
          announce(label + ' is applied to this order.');
          push('loyalty_drawer_claim_success', { loyalty_reward: label });
        } else {
          /* Claimed, but the cart still reports the code as not applicable after the retries. The claim is real and
             the code is the member's, so say exactly that and give them the code. UNVERIFIED 17 Oct: whether this
             is Shopify propagation delay (theory) or something else; retest on a test account. */
          setTimeout(function () {
            var r = document.querySelector('cart-drawer [data-ccrw]');
            var m = r && r.querySelector('[data-ccrw-msg]');
            if (m) { m.hidden = false; m.className = 'ccrw__ok'; m.textContent = 'Your ' + label + ' is saved. If it isn’t in your total yet, enter ' + pendingCode + ' at checkout.'; }
          }, 200);
          announce('Your ' + label + ' is saved. Enter code ' + pendingCode + ' at checkout if it is not in your total yet.');
          push('loyalty_drawer_claim_pending', { loyalty_reward: label });
        }
      })
      .catch(function (err) {
        var reason = (err && err.ccrw) || reasonOf(err);
        if (!(err && err.ccrw)) warn(step + ' threw', err);
        dlog(step + ' error ' + short(reason) + (err && err.message ? ' ' + err.message : ''));
        if (claimed && code) {
          /* The claim worked but applying failed: the code belongs to the member and is saved here for Apply. */
          row.removeAttribute('data-ccrw-busy');
          if (btn) { btn.disabled = false; btn.textContent = 'Use'; }
          var m = row.querySelector('[data-ccrw-msg]');
          if (m) { m.hidden = false; m.className = 'ccrw__ok'; m.textContent = 'Your ' + label + ' is saved. If it isn’t in your total yet, enter ' + code + ' at checkout.'; }
          announce('Your ' + label + ' is saved. Enter code ' + code + ' at checkout if it is not in your total yet.');
          push('loyalty_drawer_claim_fail', { loyalty_reward: label, status: reason.status, message: reason.message, step: step });
          return;
        }
        fail(row, btn, label, reason, step);
      });
  });

  function dropSaved(c) {
    savedWrite(savedList().filter(function (x) { return x.code.toUpperCase() !== String(c).toUpperCase(); }));
  }

  /* Saved rewards: shown first in a member row, minus any code already on the cart. */
  function paintSaved() {
    document.querySelectorAll('[data-ccrw-saved]').forEach(function (box) {
      var row = box.closest('[data-ccrw]');
      var onCart = (row && row.getAttribute('data-ccrw-codes') || '').toUpperCase().split(',');
      var hasV = row && row.getAttribute('data-ccrw-has-v') === '1';
      var list = savedList().filter(function (x) { return onCart.indexOf(x.code.toUpperCase()) < 0; });
      if (hasV) list = list.filter(function (x) { return /shipping/i.test(x.label); });
      list = list.slice(0, 3);
      var sig = list.map(function (x) { return x.code; }).join(',');
      if (box.getAttribute('data-ccrw-sig') === sig && box.children.length === list.length) return;
      box.setAttribute('data-ccrw-sig', sig);
      box.innerHTML = '';
      list.forEach(function (x) {
        var li = document.createElement('li');
        li.className = 'ccrw__item ccrw__item--saved';
        var sp = document.createElement('span');
        var nm = document.createElement('span'); nm.className = 'ccrw__name'; nm.textContent = 'Your saved ' + x.label;
        var cd = document.createElement('span'); cd.className = 'ccrw__pts'; cd.textContent = x.code;
        sp.appendChild(nm); sp.appendChild(cd);
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'ccrw__use'; b.textContent = 'Apply';
        b.setAttribute('data-ccrw-apply', x.code); b.setAttribute('data-ccrw-label', x.label); b.setAttribute('data-ccrw-txt', 'Apply');
        b.setAttribute('aria-label', 'Apply your saved ' + x.label);
        li.appendChild(sp); li.appendChild(b); box.appendChild(li);
      });
      box.hidden = !box.children.length;
    });
  }

  /* Apply a saved code: no claim, only the cart discount. */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-ccrw-apply]');
    if (!btn) return;
    event.preventDefault();
    var row = btn.closest('[data-ccrw]');
    if (!row || row.hasAttribute('data-ccrw-busy')) return;
    var code = btn.getAttribute('data-ccrw-apply');
    var label = btn.getAttribute('data-ccrw-label') || 'reward';
    row.setAttribute('data-ccrw-busy', '');
    btn.disabled = true;
    btn.textContent = 'Adding';
    push('loyalty_drawer_saved_apply', { loyalty_reward: label });
    pendingCode = code;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (cart) {
        var codes = (cart.discount_codes || []).map(function (d) { return d.code; })
          .filter(function (c) { return c && c.toUpperCase() !== code.toUpperCase(); });
        codes.push(code);
        return fetch((window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: codes.join(','), sections: ['cart-drawer', 'cart-icon-bubble'] })
        }).then(function (r) { return r.json(); });
      })
      .then(function (state) {
        var hit = findApplied(state);
        if (!hit || !hit.applicable) { warn('saved code not applicable', state && state.discount_codes); var e = new Error('not applicable'); e.ccrw = { status: hit ? 'not applicable' : 'not applied', message: code }; throw e; }
        dropSaved(code);
        redraw(state);
        lionCartSync();
        announce(label + ' is applied to this order.');
        push('loyalty_drawer_saved_success', { loyalty_reward: label });
      })
      .catch(function (err) {
        var reason = (err && err.ccrw) || reasonOf(err);
        if (!(err && err.ccrw)) warn('apply threw', err);
        fail(row, btn, label, reason, 'saved');
      });
  });

  /* Seamless free products: LoyaltyLion adds the reward line itself; redraw so the drawer shows it. */
  function hookLion() {
    var lion = window.lion;
    if (!lion || typeof lion.on !== 'function' || lion.__ccrwHooked) return !!(lion && lion.__ccrwHooked);
    lion.__ccrwHooked = true;
    lion.on('cart.addedItem', function () { dlog('LL event cart.addedItem: drawer redraw'); sectionsRefresh(); });
    lion.on('cart.removedItems', function () { dlog('LL event cart.removedItems: drawer redraw'); sectionsRefresh(); });
    return true;
  }

  function init() {
    sync();
    paintSaved();
    repaintFail();
    applyRefused();
    if (dbg) { debugPaint(); setTimeout(debugPaint, 3000); setTimeout(debugPaint, 8000); }
    var tries = 0;
    var t = setInterval(function () { if (hookLion() || ++tries > 20) clearInterval(t); }, 500);
    var d = document.querySelector('cart-drawer');
    if (d && 'MutationObserver' in window) {
      var timer = null;
      new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(function () { sync(); paintSaved(); repaintFail(); applyRefused(); debugPaint(); }, 60); })
        .observe(d, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
